// The documents a user accepts before using Veyumo, as Russian law asks: the user agreement, and — a
// document of its own — the consent to the processing of personal data under the policy (web/legal); and the
// policy of cookies: the app sets none, only keeps its own in the browser, and the landing counts visits with
// Yandex Metrica. Their version, and whether this browser accepted it: a new version is asked for again.
import { keep, stored } from "./account.ts";
import { changed } from "./store.ts";

// Whether the documents are shown, which build.mjs puts into the code: they are hidden while their operator
// is being registered.
declare const __LEGAL__: boolean;

/** Whether the documents are shown. Hidden, they are not asked for — as if accepted — nor linked. */
export const SHOWN: boolean = __LEGAL__;

/** The version of the documents: the date of their edition. A change of what they say changes it, and so does
 * their coming back: the day they are shown again. */
export const LEGAL_VERSION = "2026-10-12";

/** The key of the version accepted in this browser's storage. */
const KEY = "xq.legal";

/** The documents, as their links say them. */
export const DOCUMENTS = [
  { href: "/legal/terms.html", title: "Пользовательское соглашение" },
  { href: "/legal/privacy.html", title: "Политика обработки персональных данных" },
  { href: "/legal/consent.html", title: "Согласие на обработку персональных данных" },
  { href: "/legal/cookies.html", title: "Политика использования файлов cookie" },
];

/** Whether this browser accepted the documents of this version. */
export function accepted(): boolean {
  return !SHOWN || stored(KEY) === LEGAL_VERSION;
}

/** The documents of this version accepted in this browser. */
export function accept(): void {
  keep(KEY, LEGAL_VERSION);
  changed();
}
